export const media = {
    sm: `(max-width: 750px)`,
    md: `(min-width: 751px)`,
    lg: `(min-width: 1600px)`
}